import { render, staticRenderFns } from "./EmptyImage.vue?vue&type=template&id=f06639de&scoped=true"
import script from "./EmptyImage.vue?vue&type=script&lang=js"
export * from "./EmptyImage.vue?vue&type=script&lang=js"
import style0 from "./EmptyImage.vue?vue&type=style&index=0&id=f06639de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06639de",
  null
  
)

export default component.exports